import React from 'react';

const WE_BUY = [
  'Nintendo Switch games',
  'Retro Games Sega, Nintendo (NES–3DS), etc.',
  'PS1–PS5 & Xbox titles ($5+ resale)',
  'Clean, working consoles (Switch, PS4/PS5, Xbox One/Series X, GameCube, N64, DS/3DS, PS2 Slim)',
  'Pokémon games & Nintendo handhelds (premium rates)',
  'OEM controllers & required cables',
];

const WE_DO_NOT_BUY = [
  'Sports titles or Shovelware (Just Dance, Zumba, Carnival, Kinect)',
  'Loose or scratched discs or broken, yellowed, incomplete, or untested systems',
  'Games under $5 resale bulk, low-quality titles, or excessive duplicates',
];

const Heading = ({ children }) => (
  <h2 className="text-sm font-bold uppercase tracking-wide text-[#2F5F92] mt-8 mb-3">{children}</h2>
);

const BulletList = ({ items }) => (
  <ul className="space-y-1">
    {items.map((i) => <li key={i}>• {i}</li>)}
  </ul>
);

const Rate = ({ label, children }) => (
  <p><strong>{label}</strong> {children}</p>
);

const VideoGameTradePolicy = () => (
  <div className="min-h-screen bg-gray-50 pt-24 pb-12">
    <div className="container max-w-4xl text-[#1F1F1F]">
      <h1 className="text-3xl font-bold text-[#17365D] border-b-2 border-[#4F81BD] pb-2 mb-4">
        Next Level Games – Updated Video Game Trade Policy
      </h1>

      <Heading>We Buy</Heading>
      <BulletList items={WE_BUY} />

      <Heading>We Do NOT Buy</Heading>
      <BulletList items={WE_DO_NOT_BUY} />

      <Heading>Premium Trade-In Rates (Pokémon &amp; Handhelds)</Heading>
      <BulletList items={[
        'Nintendo Handheld Systems & Pokémon Games: 80% credit / 70% cash',
        'Special Editions / Limited Consoles: Custom evaluation',
      ]} />

      <Heading>Standard Game Rates</Heading>
      <Rate label="High-Value ($50+ resale):">70% credit / 60% cash</Rate>
      <Rate label="Mid-Value ($10–$49):">50% credit / 40% cash</Rate>
      <Rate label="Low-Value ($5–$9):">30% credit / 15% cash (must be clean, complete, non-duplicate)</Rate>

      <Heading>Console Rates</Heading>
      <Rate label="Latest Gen (Switch/PS5/XSX):">80% credit / 65% cash</Rate>
      <Rate label="Modern (Post-2005):">40% credit / 25% cash</Rate>
      <Rate label="Vintage (Pre-2005):">70% credit / 55% cash</Rate>

      <Heading>Accessories Rates</Heading>
      <Rate label="OEM Accessories">60% Credit / 50% Cash</Rate>
      <Rate label="3rd party accessories">40% Credit / 30% Cash</Rate>
    </div>
  </div>
);

export default VideoGameTradePolicy;
